import { css } from 'linaria';

/** Горизонтальный padding DrawerContent — карточка адреса компенсирует его отрицательным margin */
const DRAWER_CONTENT_HORIZONTAL_PADDING = 36;

export const selectionGroup = css`
  gap: 16px;
`;

export const selectionGroupItem = css`
  width: 100%;
`;

export const drawerDescription = css`
  margin-bottom: 32px;
`;

export const type = css`
  display: flex;
  gap: 4px;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 4px;
`;

export const cardContent = css`
  position: relative;
  display: grid;
  grid-template-columns: 1fr auto;
  grid-template-areas:
    'title icon'
    'description .';
  column-gap: 16px;
  row-gap: 4px;
  background-color: var(--background-secondary);
  border-radius: var(--rounding-l);
  width: calc(100% + ${DRAWER_CONTENT_HORIZONTAL_PADDING}px);
  margin-top: 12px;
  margin-left: -${DRAWER_CONTENT_HORIZONTAL_PADDING}px;
  padding: 12px 16px;
`;

export const addressActionsMenu = css`
  position: fixed;
  z-index: 10001;
  min-width: 288px;
  transform: translateX(-100%);
  border-radius: var(--rounding-m);
  background-color: var(--background-primary);
  box-shadow: var(--box-shadow-m);
  max-width: 288px;
`;

export const addressActionsList = css`
  border-radius: var(--rounding-m);
`;

export const cardTitle = css`
  grid-area: title;
`;

export const cardDescription = css`
  grid-area: description;
`;

export const cardIcon = css`
  grid-area: icon;
  max-height: 24px;
`;

export const red = css`
  li {
    color: var(--attention-primary);
  }
`;
